export default __webpack_public_path__ + "static/media/IMG_3080_7_11zon.532a04b7.jpg";